'use client';

import { createContext } from 'react';

import { BehaviorSubject } from 'rxjs';

import type { SocketEvent, SocketEventArgs } from '../../types/SocketEvent';

export type GatewayConnectionStatus =
  | 'idle'
  | 'connecting'
  | 'connected'
  | 'disconnected'
  | 'error';

export type ChatGatewayEventListener<T extends SocketEvent> = (
  data: SocketEventArgs[T],
) => void;

export interface ChatGatewayContextValue {
  status$: BehaviorSubject<GatewayConnectionStatus>;
  reconnect: () => void;
  addEventListener: (
    name: string,
    listener: (data: unknown) => void,
    tag?: string,
  ) => () => void;
}

export const ChatGatewayContext = createContext<ChatGatewayContextValue | null>(
  null,
);
